export default __webpack_public_path__ + "static/media/2d.e7ee0af0.png";